import { RecHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const PostProgramLevelInstanceSubmitLevelData = (programLevelInstanceId, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const programLevelInstanceIdForUrl = programLevelInstanceId ? encodeURIComponent(programLevelInstanceId) : 'NaN';
    const url = `/ProgramLevelInstance/${programLevelInstanceIdForUrl}/SubmitLevel`;

    RecHttpHelper(url, 'POST')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoaded: true,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PostProgramLevelInstanceSubmitLevelData;